export default "__VITE_ASSET__e18cb9d8__"